import { CODE_CHALLENGE_METHOD, preparePkceChallenge } from '@@auth/utils/pkce';
import { resolveAuthenticationApiUrl } from '@@config';

/**
 * Starts the OAuth2 authorization code flow with PKCE (RFC 7636).
 */
export const login = async (apiEnv?: string) => {
    const codeChallenge = await preparePkceChallenge();

    const challengeParams = new URLSearchParams({
        code_challenge: codeChallenge,
        code_challenge_method: CODE_CHALLENGE_METHOD,
    });

    window.location.assign(`${resolveAuthenticationApiUrl(apiEnv)}&${challengeParams}`);
};
